class ProductForm extends HTMLElement {
  constructor() {
    super();   
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('#cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    const embroideryCheckbox = document.getElementById('embroidery-checkbox');
    const formData = JSON.parse(serializeForm(this.form));
    const originalSKU = formData.id;

    const submitter = evt.submitter;

    if (embroideryCheckbox && embroideryCheckbox.checked) {
      this.handleAddToCartWithEmbroidery(formData, originalSKU, submitter);
    } else {
      this.handleAddToCart(formData, submitter);
    }
  }

  handleAddToCartWithEmbroidery(formData, originalSKU, submitter) {
    const submitButton = submitter || this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const embroideryID = Date.now().toString(36);

    const embroideryText = document.getElementById('embroidery-text');
    const embroideryFont = document.querySelector('[name="embroidery-font"]:checked');
    const embroideryColor = document.querySelector('[name="embroidery-color"]:checked');

    let props = {};
    const propertyInputs = this.form.querySelectorAll('.product-input__property');
    propertyInputs.forEach((input) => {
      const inputName = input.getAttribute('data-name');
      props[inputName] = input.value;
    });
    props['Product SKU'] = originalSKU;
    props['_embroidery_id'] = embroideryID;
    props['_LPROP'] = 'FINAL SALE';
    props['Embroidery Text'] = embroideryText.value;
    props['Embroidery Font'] = embroideryFont.value;
    props['Embroidery Color'] = embroideryColor.value;
    props['Item is'] = 'Final Sale';

    const body = JSON.stringify({
      items: [
        {
          ...formData,
          properties: props
        },
        {
          id: '42080058998853',
          quantity: '1',
          properties: {
            '_embroidery_id': embroideryID,
            '_LPROP': 'FINAL SALE',
            'Product SKU': originalSKU
          }
        }
      ],
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => {
        console.log('Items added to cart', response);
        return response.json();
      })
      .then((parsedState) => {
        theme.addToCartOk();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        document.querySelector(".cart-drawer__close").addEventListener("click", function (e) {
          e.preventDefault();
          theme.closeCartDrawer();
        });
      });
  }

  handleAddToCart(formData, submitter) {
    const submitButton = submitter || this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    
    let props = {};
    
    const propertyInputs = this.form.querySelectorAll('.product-input__property');
    propertyInputs.forEach((input) => {
      const inputName = input.getAttribute('data-name');
      const inputValue = input.value;
      if(inputName != "_narvar"){
        props[inputName] = input.value;
      }
    });

    const body = JSON.stringify({
      ...formData,
      properties: props,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    console.log('body - single item', body);
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => {
        console.log('Original item added to cart', response);
        return response.json();
      })
      .then((parsedState) => {
        theme.addToCartOk();
      })
      .catch((e) => {
        console.error(e);
      })
      .then(() => {
        console.log('RELOAD')

        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        document.querySelector(".cart-drawer__close").addEventListener("click", function (e) {
          e.preventDefault();
          theme.closeCartDrawer();
        });
      });
  }

  renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-count]',
      }
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('product-form', ProductForm);
